import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import api from 'lib/api';
import DateTime from '_class/DateTime';
import { trackImmersiveReaderError } from 'helpers/insights';
import { getRootUrl } from 'helpers/url';
import { isUserStudent, isUserTeacher } from 'helpers/user';
import swal from 'sweetalert2';
import { getDescription } from 'helpers/content';
import { getAssignmentAssessment, createStudentAssessment, updateAssessment } from "actions/assessments";
import { getBlocksByReference, clearBlocksOnReference } from 'actions/blocks';
import { deleteAssignmentFromStore, getAssignmentKnowledgeCollections, getFolderFiles, getTaskDetails, setActiveAssignment, getAssignmentStatus, getAssignmentSection, updateAssignment, clearAssignmentSection, createAssignmentTaskWorkspace } from 'actions/assignments';
import { setPageTitle } from 'actions/header';
import { addError } from 'actions/index';
import { getStudentAssessment, getStudentAssessments } from 'actions/studentassessments';
import { getReaderParameters } from 'actions/user';
import Message from '../Partials/Message';
import Bookmark from '../Partials/Bookmark';
import AssignmentForm from "containers/Forms/AssignmentForm/AssignmentForm";
import AssessmentForm from 'containers/Forms/AssessmentForm';
import TeacherAdjustments from "containers/AdditionalAdjustments/Display/TeacherAdjustments";
import Modal from "containers/Modals/Modal";
import CloneButton from "containers/SinglePages/Partials/CloneButton";
import AssessmentsConsumer from 'components/BlockAssessments/Consumer';
import UserAssignment from "components/List/UserAssignment";
import UserGroupAssignment from "components/List/UserGroupAssignment";
import AttachedDocuments from "components/Presentation/Documents/AttachedDocuments";
import AttachedUserDocuments from "components/Presentation/Documents/AttachedUserDocuments";
import UploadDocument from "components/Presentation/Documents/UploadDocument";
import FileList from "components/Presentation/FileList/FileList";
import PostContent from "components/Presentation/PostContent";
import Status from "components/Presentation/Status";
import { ASSESSMENT_TYPES } from "components/BlockAssessments/AssessmentTypes";
import * as plagiarismActions from 'actions/plagiarism';
import { ColorLabel, ColorLabelContainer, Expandable, List, Spinner, Collapsible } from 'UI';
import { Block as ContentBlock, Button, ButtonGroup, Icon } from "@haldor/ui";
import { Immersive_Reader } from "UI/Icons";
import moment from 'moment';

var ImmersiveReader = require('@microsoft/immersive-reader-sdk');

var HaldorAssignment = /*#__PURE__*/function (_Component) {
  _inherits(HaldorAssignment, _Component);

  var _super = _createSuper(HaldorAssignment);

  function HaldorAssignment(props) {
    var _this;

    _classCallCheck(this, HaldorAssignment);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.clearAssignmentSection();

      _this.props.setActiveAssignment();

      ImmersiveReader.close();

      if (_this.timer != null) {
        clearTimeout(_this.timer);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.assignment.id > 0) {
        _this.reload();
      } // this will update reducer variable (this.props.hasValidPlagiarismLicense)


      _this.props.validatePlagiarismLicense(_this.props.activeSchool);
    });

    _defineProperty(_assertThisInitialized(_this), "checkAssignmentTaskStatus", function () {
      var assignment = _this.props.assignment;
      var isStudent = isUserStudent(_this.props.currentUser);

      if (assignment != null && isStudent && assignment.status !== 'ASSIGNMENT_LOCKED') {
        if (assignment.created != '0001-01-01T00:00:00') {
          var task = assignment.tasks[0];

          if (task == null) {
            return null;
          }

          if (task.status == 'ASSIGNMENT_TASK_NOT_STARTED') {
            var url = "assignments/Student/Status?assignmentTaskId=".concat(task.id, "&status=ASSIGNMENT_TASK_STARTED");
            api.put(url);
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "checkAssignmentTaskWorkspace", function () {
      var assignment = _this.props.assignment;
      var isStudent = isUserStudent(_this.props.currentUser);

      if (assignment != null && isStudent) {
        var task = assignment.tasks[0];

        if (task != null && !task.workspace) {
          _this.props.createAssignmentTaskWorkspace(assignment.id, task.id).then(function () {
            _this.reloadAssignment();
          });
        }
      } else if (assignment.created != '0001-01-01T00:00:00' && !assignment.locked && !isStudent) {
        if (assignment.tasks.some(function (task) {
          return !task.workspace;
        })) {
          swal.fire({
            title: _this.props.translate('The-assignment-needs-to-be-updated'),
            text: _this.props.translate('One-or-more-students-do-not-have-access-to-the-tasks-workspace.-Update-the-assignment-to-fix-the-problem.'),
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonText: _this.props.translate('Update-assignment')
          }).then(function (result) {
            if (result.value != null) {
              _this.props.updateAssignment(assignment).then(function () {
                _this.props.getTaskDetails(assignment.id).then(function () {
                  _this.fetchStatusAfterDelay();
                });
              });
            }

            ;
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "fetchStatusAfterDelay", function () {
      var getStatus = function getStatus() {
        _this.props.getAssignmentStatus(_this.props.assignment.id).then(function () {
          clearTimeout(_this.timer);
          _this.timer = null;
          var assignmentEditedDate = moment(_this.props.assignment.edited).format();
          /** substract 2 hours from now and if assignmentEditedDate bigger then run status call if assignment is locked  */

          var currentDate = moment(moment().utc().add(-2, 'hours')).format();

          if (_this.props.assignment.created != '0001-01-01T00:00:00' && !_this.props.assignment.locked) {
            _this.reloadAssignment(true);
          } else {
            if ((_this.props.assignment.created == '0001-01-01T00:00:00' || _this.props.assignment.locked) && assignmentEditedDate > currentDate) {
              // Run this method again
              _this.fetchStatusAfterDelay();
            }
          }
        });
      };

      if (_this.timer === null) {
        setTimeout(getStatus, 10000);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "reload", function () {
      var assignment = _this.props.assignment;
      var student = isUserStudent(_this.props.currentUser);
      var teacher = isUserTeacher(_this.props.currentUser);
      var promises = [];

      if (assignment.assessmentType == 'BUDDY' || assignment.assessmentType == 'SELF') {
        if (teacher) {
          promises.push(_this.props.getStudentAssessments(assignment.id));
        } else if (student) {
          promises.push(_this.props.getStudentAssessment(assignment.id, _this.props.currentUser.id));
        }
      }

      promises.push(_this.props.getAssignmentSection(assignment.sectionId));
      promises.push(_this.props.getAssignmentAssessment(assignment.id));
      Promise.all(promises).then(function () {
        if (assignment != null) {
          _this.props.setPageTitle(assignment.title);

          if (_this.props.assignment.created == '0001-01-01T00:00:00' || _this.props.assignment.locked) {
            _this.fetchStatusAfterDelay();
          }
        }

        _this.props.getBlocksByReference(_this.props.assignment.id, 'ASSIGNMENT').then(function () {
          _this.setState({
            loadingBlocks: false
          });
        });

        _this.checkAssignmentTaskStatus();

        _this.checkAssignmentTaskWorkspace();

        _this.setState({
          loading: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "reloadAssignment", function () {
      var skipLoading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!skipLoading) {
        _this.setState({
          loading: true
        });
      }

      var promises = [];
      promises.push(_this.props.getAssignmentAssessment(_this.props.assignment.id));
      promises.push(_this.props.getTaskDetails(_this.props.assignment.id));
      promises.push(_this.props.getBlocksByReference(_this.props.assignment.id, 'ASSIGNMENT'));
      Promise.all(promises).then(function () {
        if (_this.props.assignment.locked) {
          // Is updating
          _this.fetchStatusAfterDelay();
        }

        if (_this.props.assignment === null) [//{assignmentId}/tasks/{taskId}/workspacepermission
        ];

        _this.props.setPageTitle(_this.props.assignment.title);

        _this.setState({
          loading: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "runImmersiveReader", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, assignment, currentUser, localLanguage, data, reader;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, assignment = _this$props.assignment, currentUser = _this$props.currentUser;
              localLanguage = localStorage.getItem('language');
              console.log('run Microsoft Immersive Reader', localLanguage, currentUser.id);
              data = {
                title: assignment.title,
                chunks: [{
                  content: '<h1>' + assignment.title + '</h1>',
                  mimeType: 'text/html'
                }, {
                  content: getDescription(assignment.description),
                  mimeType: 'text/html'
                }]
              };
              _context.next = 6;
              return _this.props.getReaderParameters();

            case 6:
              reader = _this.props.reader;
              ImmersiveReader.launchAsync(reader.token, reader.subdomain, data, {
                uiLang: localLanguage // Set immersive reader UI language to selected lang in Haldor Edu

              })["catch"](function (error) {
                console.error('error', error);
                trackImmersiveReaderError(error, currentUser.id);
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "pupilStatusIndicator", function (status) {
      var assessed = false;

      if (_this.props.assessments != null) {
        if (_this.props.assessments.length > 0) {
          assessed = true;
        }
      }

      if (assessed == false) {
        if (status === 'ASSIGNMENT_TASK_NOT_STARTED') {
          return /*#__PURE__*/React.createElement("span", {
            className: "dot dot-gray"
          }, _this.props.translate('not-started'));
        } else if (status === 'ASSIGNMENT_TASK_STARTED') {
          return /*#__PURE__*/React.createElement("span", {
            className: "dot dot-gray"
          }, _this.props.translate('started'));
        } else if (status === 'ASSIGNMENT_TASK_SUBMITTED' && assessed == false) {
          return /*#__PURE__*/React.createElement("span", {
            className: "dot dot-yellow"
          }, _this.props.translate('submitted'));
        } else if (status === 'ASSIGNMENT_TASK_NOT_COMPLETE') {
          return /*#__PURE__*/React.createElement("span", {
            className: "dot dot-red"
          }, _this.props.translate('not-complete'));
        } else if (status === 'ASSIGNMENT_TASK_CAN_DEVELOP') {
          return /*#__PURE__*/React.createElement("span", {
            className: "dot dot-orange"
          }, _this.props.translate('can-develop'));
        }
      } else {
        if (status === 'ASSIGNMENT_TASK_NOT_COMPLETE') {
          return /*#__PURE__*/React.createElement("span", {
            className: "dot dot-red"
          }, _this.props.translate('assessed'), " - ", _this.props.translate('not-complete'));
        } else if (status === 'ASSIGNMENT_TASK_CAN_DEVELOP') {
          return /*#__PURE__*/React.createElement("span", {
            className: "dot dot-orange"
          }, _this.props.translate('assessed'), " - ", _this.props.translate('can-develop'));
        } else {
          return /*#__PURE__*/React.createElement("span", {
            className: "dot dot-green"
          }, _this.props.translate('assessed'));
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "refreshDocuments", function () {
      var documentRefresh = _this.state.documentRefresh;
      documentRefresh++;

      _this.setState({
        documentRefresh: documentRefresh
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onUploadError", function (uploadError) {
      if (uploadError.data == 'Task already submitted') {
        _this.props.addError(_this.props.translate('task-already-submitted'), 'error');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "assignmentIndicator", function (status) {
      var assignment = _this.props.assignment;

      if (assignment.published == '0001-01-01T00:00:00') {
        return /*#__PURE__*/React.createElement("span", {
          className: "dot dot-gray"
        }, _this.props.translate('Draft'));
      }

      if (status === 'ASSIGNMENT_OPEN') {
        return /*#__PURE__*/React.createElement("span", {
          className: "dot dot-green"
        }, _this.props.translate('Open'));
      } else if (status === 'ASSIGNMENT_CLOSED') {
        return /*#__PURE__*/React.createElement("span", {
          className: "dot dot-red"
        }, _this.props.translate('Hidden'));
      } else if (status === 'ASSIGNMENT_DELETED') {
        return /*#__PURE__*/React.createElement("span", {
          className: "dot dot-red"
        }, _this.props.translate('Deleted'));
      } else if (status === 'ASSIGNMENT_LOCKED') {
        return /*#__PURE__*/React.createElement("span", {
          className: "dot dot-red"
        }, _this.props.translate('Locked'));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleForm", function () {
      _this.setState({
        formOpen: !_this.state.formOpen
      });
    });

    _defineProperty(_assertThisInitialized(_this), "markStudentForConversation", function (student) {
      _this.setState({
        studentConversation: student
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onConversationClose", function () {
      _this.setState({
        studentConversation: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "openStudentConversation", function () {
      var _this$props2 = _this.props,
          currentUser = _this$props2.currentUser,
          assignment = _this$props2.assignment;

      _this.setState({
        studentConversation: assignment.teacher
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderMembersForStudent", function () {
      if (_this.props.assignment.tasks.length > 0) {
        var task = _this.props.assignment.tasks.find(function (task) {
          return task.assignedTo.indexOf(_this.props.currentUser.id) > -1;
        });

        if (task == null) {
          return null;
        }

        var assignedTo = task.assignedTo.split(';');
        var users = [];
        assignedTo.forEach(function (user) {
          task.students.find(function (student) {
            if (student.userId == user) {
              users.push(student);
            }
          });
        });
        return users.map(function (student) {
          return /*#__PURE__*/React.createElement("div", null, student.firstName + ' ' + student.lastName);
        });
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "statusSwitcher", function () {
      var _assignment$tasks$;

      var assignment = _this.props.assignment;
      var task = assignment.tasks[0];
      var assignmentTaskLocked = ((_assignment$tasks$ = assignment.tasks[0]) === null || _assignment$tasks$ === void 0 ? void 0 : _assignment$tasks$.assignmentTaskAssignees.filter(function (x) {
        return x.permission === '0';
      }).length) > 0;

      if (assignment.created != '0001-01-01T00:00:00') {
        if (task.status === 'ASSIGNMENT_TASK_NOT_STARTED' || task.status === 'ASSIGNMENT_TASK_STARTED' || task.status === 'ASSIGNMENT_TASK_NOT_COMPLETE') {
          return /*#__PURE__*/React.createElement(Button, {
            style: {
              marginTop: 5
            },
            onClick: function onClick() {
              return _this.onSubmitAssignment();
            },
            disabled: assignment.status == 'ASSIGNMENT_LOCKED' || assignmentTaskLocked
          }, _this.props.translate('Turn in'));
        } else if (task.status === 'ASSIGNMENT_TASK_CAN_DEVELOP') {
          return /*#__PURE__*/React.createElement(Button, {
            style: {
              marginTop: 5
            },
            onClick: function onClick() {
              return _this.onSubmitAssignment();
            }
          }, _this.props.translate('submit-complement'));
        }
      } else {
        return /*#__PURE__*/React.createElement("div", null);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderPrintButton", function (id) {
      var url = "/print/assignment/".concat(id);

      if (getRootUrl() != '/') {
        url = "/print/assignments-tab/".concat(id);
      }

      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 5
        }
      }, /*#__PURE__*/React.createElement(Link, {
        style: {
          display: 'inline'
        },
        to: url
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Printer"
      }), " ", _this.props.translate('printable-view'))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderDeleteButton", function () {
      if (_this.props.assignment.isDeletable) {
        return /*#__PURE__*/React.createElement(Button, {
          type: "secondary",
          style: {
            marginTop: 5
          },
          onClick: _this.toggleDeletion
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Bin"
        }), " ", _this.props.translate('Delete'));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "taskContent", function (assignment, section, teacherOwnsAssignment) {
      var _this$props3, _assessmentBlocks;

      var isTeacher = isUserTeacher(_this.props.currentUser);
      var taskWorkSpace = '';
      var rootUrl = '';

      if (isTeacher == false) {
        var sectionUrl = new URL(section.classroomUrl);
        taskWorkSpace = "".concat(sectionUrl.protocol, "//").concat(sectionUrl.hostname).concat(assignment.tasks[0].workspace);
        rootUrl = "".concat(sectionUrl.protocol, "//").concat(sectionUrl.hostname);
      }

      var sectionUrl = new URL(section.classroomUrl);
      var folderUrl = "".concat(sectionUrl.protocol, "//").concat(sectionUrl.hostname).concat(assignment.workspace);
      var associatedMatrices = [];
      var subjects = [];
      var assessmentBlocks = [];

      if (assignment.associatedMatrices != null) {
        assignment.associatedMatrices.forEach(function (matrix) {
          if (matrix._ParagraphSet != null && matrix._ParagraphSet.length > 0) {
            associatedMatrices.push(matrix);
          }
        });
        associatedMatrices.forEach(function (matrice) {
          if (subjects.indexOf(matrice.course.subjectId) == -1) {
            subjects.push(matrice.course.subjectId);
          }
        });
      }

      if (((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.blocks) != null) {
        assessmentBlocks = _toConsumableArray(_this.props.blocks).filter(function (block) {
          return block.type == 'Haldor.Blocks.AssessmentBlock' && block.resources.length > 0;
        });
      }

      var expiredCourses = [];

      if (((_assessmentBlocks = assessmentBlocks) === null || _assessmentBlocks === void 0 ? void 0 : _assessmentBlocks.length) > 0) {
        var _assessmentBlocks2;

        (_assessmentBlocks2 = assessmentBlocks) === null || _assessmentBlocks2 === void 0 ? void 0 : _assessmentBlocks2.forEach(function (content) {
          var _content$resources;

          content === null || content === void 0 ? void 0 : (_content$resources = content.resources) === null || _content$resources === void 0 ? void 0 : _content$resources.forEach(function (resources) {
            var _resources$value;

            switch (resources.referenceType) {
              case 'matrix':
                var matrixId = resources.referenceId;
                var detail = (_resources$value = resources.value) === null || _resources$value === void 0 ? void 0 : _resources$value.details.find(function (detail) {
                  return detail.matrixID == matrixId;
                });

                if (detail != null && detail.endDate != null && moment(detail.endDate).isBefore(moment())) {
                  expiredCourses.push(detail.courseID);
                }

                break;

              default:
                break;
            }

            if ((resources === null || resources === void 0 ? void 0 : resources.value) != null) {
              var _resources$value2;

              if (subjects.indexOf((_resources$value2 = resources.value) === null || _resources$value2 === void 0 ? void 0 : _resources$value2.subjectId) == -1) {
                var _resources$value3;

                subjects.push(parseInt((_resources$value3 = resources.value) === null || _resources$value3 === void 0 ? void 0 : _resources$value3.subjectId));
              }
            }
          });
        });
      }

      var conversation = null;

      if (_this.props.conversations != null && !isTeacher) {
        conversation = _this.props.conversations.find(function (conv) {
          return conv.memberships.find(function (member) {
            return member.membershipID == _this.props.currentUser.id;
          });
        });
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "single-section form left-side",
        style: {
          paddingTop: '0'
        }
      }, /*#__PURE__*/React.createElement(ContentBlock, null, _this.props.services.immersiveReaderAssignments ? /*#__PURE__*/React.createElement(Link, {
        to: "#",
        onClick: _this.runImmersiveReader
      }, /*#__PURE__*/React.createElement("div", {
        className: "reader trigger"
      }, /*#__PURE__*/React.createElement(Immersive_Reader, null), _this.props.translate('immersive-reader'))) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'right'
        }
      }, /*#__PURE__*/React.createElement(Bookmark, {
        referenceType: "ASSIGNMENT",
        referenceId: assignment.id
      })), /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, _this.props.translate('description')), /*#__PURE__*/React.createElement(PostContent, null, assignment.description), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, _this.props.translate('Status')), assignment.created == '0001-01-01T00:00:00' ? /*#__PURE__*/React.createElement("div", {
        className: "badge-primary"
      }, _this.props.translate('task-is-creating')) : assignment.locked ? /*#__PURE__*/React.createElement("div", {
        className: "badge-primary"
      }, _this.props.translate('task-is-updating')) : /*#__PURE__*/React.createElement("div", null, isTeacher == false ? _this.pupilStatusIndicator(assignment.tasks[0].status) : _this.assignmentIndicator(assignment.status)), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, _this.props.translate('type')), /*#__PURE__*/React.createElement(Status, {
        type: "assignmentTypes",
        id: assignment.assignmentType
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, _this.props.translate('start')), /*#__PURE__*/React.createElement("div", null, new DateTime(assignment.startDate).getShortDate(true))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, _this.props.translate('end')), /*#__PURE__*/React.createElement("div", null, new DateTime(assignment.dueDate).getShortDate(true))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, _this.props.translate('assessment')), assignment.assessmentType == 'BUDDY' ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta"
      }, _this.props.translate('buddy-assessment')) : null, assignment.assessmentType == 'SELF' ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta"
      }, _this.props.translate('self-assessment')) : null), isTeacher == false && assignment.groupEnabled ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, _this.props.translate('members')), _this.renderMembersForStudent()) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, _this.props.translate('section')), assignment.section.title), assignment.courses.length > 0 ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "1rem"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, _this.props.translate("courses")), /*#__PURE__*/React.createElement(ColorLabelContainer, null, assignment.courses.map(function (course) {
        var text = course.title;
        text = course.year != null ? text + " " + course.year : text;

        if (expiredCourses.indexOf(course.id) > -1) {
          return /*#__PURE__*/React.createElement("div", {
            className: "dot"
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "Alert_Red"
          }), " ", text);
        } else {
          return /*#__PURE__*/React.createElement(ColorLabel, {
            key: "single_assignment_course-".concat(course.id),
            tooltip: text,
            color: course.colorCode
          });
        }
      }))) : null, _this.props.services.additionalAdjustments && isTeacher && _this.props.activeSection && _this.props.activeSection.owners.filter(function (ss) {
        return ss.id == _this.props.currentUser.id;
      }).length > 0 ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement(Collapsible, {
        trigger: _this.props.translate('additional-adjustments')
      }, /*#__PURE__*/React.createElement(TeacherAdjustments, {
        groupId: assignment.sectionId,
        subjects: subjects
      }))) : null)), /*#__PURE__*/React.createElement("div", {
        className: "single-actions right-side"
      }, /*#__PURE__*/React.createElement("div", {
        className: "action-section"
      }, /*#__PURE__*/React.createElement("h3", null, _this.props.translate('tools')), _this.props.services.conversations && !isTeacher ? /*#__PURE__*/React.createElement(Button, {
        type: conversation == null ? 'secondary' : 'primary',
        onClick: _this.openStudentConversation
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Message",
        bw: true
      }), _this.props.translate('conversation'), conversation != null && conversation.unreadMessages > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "badge"
      }, /*#__PURE__*/React.createElement("span", null, conversation.unreadMessages)) : null) : null, !_this.props.services.haldor || isTeacher == false || !teacherOwnsAssignment || assignment.created == '0001-01-01T00:00:00' || assignment.locked ? null : /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick() {
          return _this.toggleModal('edit');
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Pen_Small"
      }), " ", _this.props.translate('Edit')), assignment.created != '0001-01-01T00:00:00' ? _this.renderPrintButton(assignment.id) : null, isTeacher == false && assignment.status != 'ASSIGNMENT_TASK_NOT_STARTED' && assignment.status != 'ASSIGNMENT_CLOSED' && assignment.tasks[0].workspace != null && assignment.tasks[0].assignmentTaskAssignees.find(function (assignee) {
        return assignee.permission != '0';
      }) != null && assignment.created != '0001-01-01T00:00:00' ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 5
        }
      }, /*#__PURE__*/React.createElement("a", {
        target: "_blank",
        style: {
          display: 'inline'
        },
        href: taskWorkSpace
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary"
      }, _this.props.translate('open-workspace')))) : null, isTeacher == false || assignment.workspace == '' || assignment.created == '0001-01-01T00:00:00' ? null : /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 5
        }
      }, /*#__PURE__*/React.createElement("a", {
        target: "_blank",
        style: {
          display: 'inline'
        },
        href: folderUrl
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary"
      }, _this.props.translate('open-website')))), isTeacher == false || !teacherOwnsAssignment ? null : _this.renderDeleteButton(), isTeacher && assignment.created != '' && !assignment.locked && assignment.created != '0001-01-01T00:00:00' ? _this.renderCloneButton() : null, isTeacher || assignment.status == 'ASSIGNMENT_CLOSED' ? null : _this.statusSwitcher()), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "renderCloneButton", function () {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 5
        }
      }, /*#__PURE__*/React.createElement(CloneButton, {
        onClose: _this.reloadAssignment,
        object: _this.props.assignment,
        type: "assignment"
      }, _this.props.translate('column-copy')));
    });

    _defineProperty(_assertThisInitialized(_this), "editStatus", function (taskId, value, userId) {
      return new Promise(function (resolve) {
        if (typeof value === 'string' && value.indexOf('ASSESSMENT') > -1) {
          api.put("assessments/".concat(taskId, "/type/AssignmentTask/studentId/").concat(userId, "/status/").concat(value), null).then(function () {
            _this.props.addError(_this.props.translate('changes-saved'), 'info');

            resolve();
          });
        } else {
          api.put('assignments/Student/Status?assignmentTaskId=' + taskId + '&status=' + value, null).then(function () {
            _this.props.addError(_this.props.translate('changes-saved'), 'info');

            resolve();
          });
        }

        var tasks = _this.props.assignment.tasks;
        tasks.forEach(function (task) {
          if (task.id === taskId) {
            // Change status of task.
            if (value.indexOf('ASSESSMENT') > -1) {
              task.assignedUsers.forEach(function (user) {
                if (user.id == userId) {
                  user.assessmentStatus = value;
                }
              });
            } else {
              if (task.status == 'ASSIGNMENT_TASK_SUBMITTED' && value != 'ASSIGNMENT_TASK_SUBMITTED') {
                // Old status is Inlämnad. Change users assessment to ASSESMENT STARTED
                task.assignedUsers.forEach(function (user) {
                  if (user.assessmentStatus != null) {
                    user.assessmentStatus = 'ASSESSMENT_STARTED';
                  }
                });
              }

              task.status = value;
            }
          }
        });

        _this.setState({});
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmitAssignment", function () {
      var translate = _this.props.translate;

      var that = _assertThisInitialized(_this);

      swal.fire({
        title: translate('are-you-sure'),
        text: translate('submit-task-text-prompt'),
        showCancelButton: true,
        cancelButtonText: translate('Cancel'),
        confirmButtonText: translate('submit'),
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: function () {
          var _preConfirm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    swal.getTitle().innerText = translate('Good job!');
                    swal.getHtmlContainer().innerText = translate('Please wait until the submission of the assignment is completed. The window will then close automatically.');
                    return _context3.abrupt("return", new Promise(function (resolve, reject) {
                      setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                        var task, taskId;
                        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                          while (1) {
                            switch (_context2.prev = _context2.next) {
                              case 0:
                                task = that.props.assignment.tasks;
                                taskId = task[0].id;
                                _context2.next = 4;
                                return that.editStatus(taskId, 'ASSIGNMENT_TASK_SUBMITTED', null);

                              case 4:
                                that.reloadAssignment();
                                swal.close();

                              case 6:
                              case "end":
                                return _context2.stop();
                            }
                          }
                        }, _callee2);
                      })), 8000);
                    })["catch"](function (err) {
                      return false;
                    }));

                  case 3:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          function preConfirm() {
            return _preConfirm.apply(this, arguments);
          }

          return preConfirm;
        }()
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleDeletion", function () {
      swal.fire({
        title: _this.props.translate('are-you-sure'),
        text: _this.props.translate('deletion-task-text-prompt'),
        showCancelButton: true,
        cancelButtonText: _this.props.translate('Cancel'),
        confirmButtonText: _this.props.translate('Delete')
      }).then(function (result) {
        if (result.value != null) {
          api["delete"]('assignments/' + _this.props.assignment.id).then(function (response) {
            if (response.status != 200) {
              _this.props.addError(_this.props.translate('could-not-delete-assignment'), 'error');

              return;
            }

            _this.props.deleteAssignmentFromStore(_this.props.assignment.id);

            _this.props.history.push(getRootUrl());
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function (modal) {
      var modals = _this.state.modals;
      var current = modals.findIndex(function (n) {
        return n.name === modal;
      });
      modals[current].open = !modals[current].open;

      _this.setState({
        modals: modals
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getModalState", function (modal) {
      var modals = _this.state.modals;
      var current = modals.find(function (n) {
        return n.name === modal;
      });

      if (typeof current === 'undefined') {
        console.error('Modals needs to be defined in the component state, the current modal will always be closed! Context:', modal);
        console.error("Add this to the 'modals' array in component state: { name: '" + modal + "', open: false }");
        return false;
      }

      return current.open;
    });

    _defineProperty(_assertThisInitialized(_this), "onEditFormDone", function (success, skipPrompt, reload) {
      if (success) {
        if (skipPrompt) {
          _this.toggleModal('edit');

          if (reload) {
            _this.reloadAssignment();
          }
        } else {
          _this.toggleModal('edit');
        }
      } else {
        _this.toggleModal('edit');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "closeAssessmentModal", function (skipPrompt) {
      _this.toggleModal('studentAssessment');
    });

    _defineProperty(_assertThisInitialized(_this), "closeSelfAssessmentModal", function (skipPrompt) {
      _this.toggleModal('selfAssessment');
    });

    _defineProperty(_assertThisInitialized(_this), "openStudentAssessment", function (task) {
      task.firstname = task.groupName;

      _this.setState({
        assessTask: task
      }, function () {
        _this.toggleModal('studentAssessment');
      });
    });

    _defineProperty(_assertThisInitialized(_this), "openSelfAssessment", function () {
      _this.toggleModal('selfAssessment');
    });

    _defineProperty(_assertThisInitialized(_this), "toggleTab", function (tab) {
      _this.setState({
        tab: tab
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAssessmentSubmit", function (values) {
      var _this$state$assessTas, _this$props$currentUs;

      values.studentId = values.assessorType == ASSESSMENT_TYPES.PEER ? (_this$state$assessTas = _this.state.assessTask) === null || _this$state$assessTas === void 0 ? void 0 : _this$state$assessTas.assignedTo : (_this$props$currentUs = _this.props.currentUser) === null || _this$props$currentUs === void 0 ? void 0 : _this$props$currentUs.id;
      return new Promise(function (resolve) {
        if (values.id != null) {
          var existing = _this.props.assessments.find(function (assessment) {
            return assessment.id == values.id;
          });

          _this.props.updateAssessment(values, existing, _this.props.assignment.id).then(function () {
            _this.props.getAssignmentAssessment(_this.props.assignment.id).then(function (ass) {
              resolve(1);
              values.assessorType == ASSESSMENT_TYPES.PEER ? _this.closeAssessmentModal() : _this.closeSelfAssessmentModal();
            });
          });

          return true;
        }

        values.assignmentId = _this.props.assignment.id;

        _this.props.createStudentAssessment(values).then(function () {
          _this.props.getAssignmentAssessment(_this.props.assignment.id).then(function (ass) {
            resolve(1);
            values.assessorType == ASSESSMENT_TYPES.PEER ? _this.closeAssessmentModal() : _this.closeSelfAssessmentModal();
          });
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "assignmentModals", function () {
      var assignment = _this.props.assignment;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Modal, {
        isOpen: _this.getModalState('edit'),
        title: /*#__PURE__*/React.createElement("span", null, _this.props.translate('edit-assignment'), " ", _this.props.translate('for'), ' ', _this.props.assignment.title),
        onClose: _this.onEditFormDone
      }, /*#__PURE__*/React.createElement(AssignmentForm, {
        groupid: assignment.sectionId,
        onAbort: _this.onEditFormDone,
        editView: true,
        cloneView: false
      })));
    });

    _this.state = {
      loading: true,
      modals: [{
        name: 'edit',
        open: false
      }, {
        name: 'studentAssessment',
        open: false
      }, {
        name: 'selfAssessment',
        open: false
      }],
      tab: 'assessments',
      documentRefresh: 0,
      studentConversation: null,
      loadingBlocks: false,
      loadingDocuments: false,
      assessTask: null
    };
    _this.timer = null;
    return _this;
  }

  _createClass(HaldorAssignment, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var documentRefresh = this.state.documentRefresh;
      var _this$props4 = this.props,
          assignment = _this$props4.assignment,
          activeSection = _this$props4.activeSection;
      var isTeacher = isUserTeacher(this.props.currentUser);
      if (this.state.loading) return /*#__PURE__*/React.createElement(Spinner, {
        center: true
      });

      if (assignment != null && activeSection != null) {
        var _completedPeerAssessm, _completedPeerAssessm2, _this$state$assessTas2, _assignment$tasks$2;

        var teacherOwnsAssignment = this.props.sections.find(function (t) {
          return t.id == _this2.props.assignment.sectionId && t.userRole == 'OWNER';
        }) == null ? false : true;
        var completedTeacherAssessment = null;
        var completedPeerAssessments = [];
        var completedSelfAssessment = null;
        var assessmentBlocks = [];
        var taskWorkSpace = "";
        var rootUrl = "";
        var selfAssessments = [];
        var peerAssessments = [];
        var teacherAssessments = [];
        var sectionUrl = new URL(activeSection.classroomUrl);

        if (isTeacher == false) {
          taskWorkSpace = "".concat(sectionUrl.protocol, "//").concat(sectionUrl.hostname).concat(assignment.tasks[0].workspace);
          rootUrl = "".concat(sectionUrl.protocol, "//").concat(sectionUrl.hostname);
        }

        if (!isTeacher && this.props.assessments.length > 0) {
          var _this$props$assessmen, _this$props$assessmen2;

          completedPeerAssessments = this.props.assessments.filter(function (assessment) {
            return assessment.assessorType == ASSESSMENT_TYPES.PEER;
          });
          completedSelfAssessment = (_this$props$assessmen = this.props.assessments.find(function (assessment) {
            return assessment.assessorType == ASSESSMENT_TYPES.SELF;
          })) !== null && _this$props$assessmen !== void 0 ? _this$props$assessmen : null;
          completedTeacherAssessment = (_this$props$assessmen2 = this.props.assessments.find(function (assessment) {
            return assessment.assessorType == ASSESSMENT_TYPES.TEACHER || assessment.assessorType == null;
          })) !== null && _this$props$assessmen2 !== void 0 ? _this$props$assessmen2 : null;
        }

        if (this.props.blocks != null) {
          var _assessmentBlocks$fil, _assessmentBlocks$fil2, _assessmentBlocks$fil3;

          assessmentBlocks = _toConsumableArray(this.props.blocks).filter(function (block) {
            return block.type == 'Haldor.Blocks.AssessmentBlock' && block.resources.length > 0;
          });
          selfAssessments = (_assessmentBlocks$fil = assessmentBlocks.filter(function (block) {
            return block.assessmentType == ASSESSMENT_TYPES.SELF && block.resources.length > 0;
          })) === null || _assessmentBlocks$fil === void 0 ? void 0 : _assessmentBlocks$fil.sort(function (a, b) {
            return a.title.localeCompare(b.title);
          });
          peerAssessments = (_assessmentBlocks$fil2 = assessmentBlocks.filter(function (block) {
            return block.assessmentType == ASSESSMENT_TYPES.PEER && block.resources.length > 0;
          })) === null || _assessmentBlocks$fil2 === void 0 ? void 0 : _assessmentBlocks$fil2.sort(function (a, b) {
            return a.title.localeCompare(b.title);
          });
          teacherAssessments = (_assessmentBlocks$fil3 = assessmentBlocks.filter(function (block) {
            return (block.assessmentType == ASSESSMENT_TYPES.TEACHER || block.assessmentType == null) && block.resources.length > 0;
          })) === null || _assessmentBlocks$fil3 === void 0 ? void 0 : _assessmentBlocks$fil3.sort(function (a, b) {
            return a.title.localeCompare(b.title);
          });
        }

        return /*#__PURE__*/React.createElement("div", {
          className: "single-task",
          key: "single-assignment-content-wrapper"
        }, teacherOwnsAssignment ? this.assignmentModals() : null, this.taskContent(assignment, activeSection, teacherOwnsAssignment), !isTeacher && assignment.studentAssessmentTasks.length > 0 ? /*#__PURE__*/React.createElement(Modal, {
          isOpen: this.getModalState('studentAssessment'),
          onClose: this.closeAssessmentModal,
          title: this.props.translate('Peer review')
        }, /*#__PURE__*/React.createElement(AssessmentForm, {
          onSubmit: this.onAssessmentSubmit,
          onClose: this.closeAssessmentModal,
          initialValues: (_completedPeerAssessm = (_completedPeerAssessm2 = completedPeerAssessments) === null || _completedPeerAssessm2 === void 0 ? void 0 : _completedPeerAssessm2.find(function (s) {
            var _this2$state$assessTa;

            return s.referenceId == ((_this2$state$assessTa = _this2.state.assessTask) === null || _this2$state$assessTa === void 0 ? void 0 : _this2$state$assessTa.id);
          })) !== null && _completedPeerAssessm !== void 0 ? _completedPeerAssessm : null,
          blocks: peerAssessments,
          referenceType: "AssignmentTask",
          referenceId: (_this$state$assessTas2 = this.state.assessTask) === null || _this$state$assessTas2 === void 0 ? void 0 : _this$state$assessTas2.id,
          items: [this.state.assessTask],
          assessmentType: ASSESSMENT_TYPES.PEER
        })) : null, !isUserTeacher(this.props.currentUser) && selfAssessments.length > 0 ? /*#__PURE__*/React.createElement(Modal, {
          isOpen: this.getModalState('selfAssessment'),
          onClose: this.closeSelfAssessmentModal,
          title: this.props.translate('self-assessment')
        }, /*#__PURE__*/React.createElement(AssessmentForm, {
          onSubmit: this.onAssessmentSubmit,
          onClose: this.closeSelfAssessmentModal,
          initialValues: completedSelfAssessment,
          blocks: selfAssessments,
          referenceType: "AssignmentTask",
          referenceId: assignment === null || assignment === void 0 ? void 0 : (_assignment$tasks$2 = assignment.tasks[0]) === null || _assignment$tasks$2 === void 0 ? void 0 : _assignment$tasks$2.id,
          assessmentType: ASSESSMENT_TYPES.SELF,
          showStudents: false
        })) : null, /*#__PURE__*/React.createElement("div", {
          style: {
            clear: 'both'
          }
        }), /*#__PURE__*/React.createElement("div", {
          style: {
            marginBottom: '3em'
          },
          className: "single-section-divider"
        }), this.props.services.conversations ? /*#__PURE__*/React.createElement(Message, {
          activeUser: this.state.studentConversation,
          assignment: assignment,
          onClose: this.onConversationClose
        }) : null, isTeacher == true && teacherOwnsAssignment ? /*#__PURE__*/React.createElement("div", {
          className: "single-section"
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            marginBottom: '1em'
          }
        }, /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(Button, {
          active: this.state.tab == 'assessments' ? true : false,
          onClick: function onClick() {
            return _this2.toggleTab('assessments');
          },
          type: "secondary"
        }, this.props.translate('assessment-tab')), /*#__PURE__*/React.createElement(Button, {
          active: this.state.tab == 'assessments' ? false : true,
          disabled: !this.props.hasValidPlagiarismLicense,
          onClick: function onClick() {
            return _this2.toggleTab('plagiarism');
          },
          type: "secondary"
        }, this.props.translate('plagiarism-check-tab')))), this.state.tab == 'assessments' ? /*#__PURE__*/React.createElement("div", null, assignment.groupEnabled ? /*#__PURE__*/React.createElement(List, {
          title: this.props.translate('students')
        }, /*#__PURE__*/React.createElement(UserGroupAssignment, {
          assignment: assignment,
          reload: this.reloadAssignment,
          printable: false,
          onConversation: this.markStudentForConversation
        })) : /*#__PURE__*/React.createElement(List, {
          title: this.props.translate('students')
        }, /*#__PURE__*/React.createElement(UserAssignment, {
          reload: this.reloadAssignment,
          printable: false,
          onConversation: this.markStudentForConversation
        }))) : /*#__PURE__*/React.createElement("div", null, this.props.hasValidPlagiarismLicense ? /*#__PURE__*/React.createElement(List, {
          title: this.props.translate('plagiarism-check-tab')
        }, /*#__PURE__*/React.createElement(FileList, {
          reloadParent: this.reloadAssignment,
          students: assignment.tasks
        })) : /*#__PURE__*/React.createElement(List, {
          title: this.props.translate("plagiarism-check-tab")
        }, /*#__PURE__*/React.createElement("div", {
          className: "color--meta text--center weight--bold"
        }, "Det finns ingen giltig licens f\xF6r att anv\xE4nda denna tj\xE4nst")))) : null, !isTeacher && assignment.studentAssessmentTasks.length && this.props.blocks ? /*#__PURE__*/React.createElement("div", {
          className: "single-section"
        }, /*#__PURE__*/React.createElement("h3", {
          style: {
            fontWeight: 500
          }
        }, this.props.translate("Peer review")), /*#__PURE__*/React.createElement("table", {
          className: "student-assessment-list"
        }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, this.props.translate('buddy')), /*#__PURE__*/React.createElement("th", null, this.props.translate('workspace')), /*#__PURE__*/React.createElement("th", null, this.props.translate('tools')))), /*#__PURE__*/React.createElement("tbody", null, assignment.studentAssessmentTasks.length > 0 ? assignment.studentAssessmentTasks.map(function (assessTask) {
          return /*#__PURE__*/React.createElement("tr", {
            key: assessTask.id
          }, /*#__PURE__*/React.createElement("td", null, assessTask.groupName), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("a", {
            target: "_blank",
            href: rootUrl + assessTask.workspace
          }, _this2.props.translate('workspace'))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Button, {
            type: "secondary",
            onClick: function onClick() {
              _this2.openStudentAssessment(assessTask);
            }
          }, _this2.props.translate('assess'))));
        }) : /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, this.props.translate('nothing-to-assess')), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null))))) : null, !isTeacher && selfAssessments.length > 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          className: "single-section"
        }, /*#__PURE__*/React.createElement("h3", {
          style: {
            fontWeight: 500
          }
        }, this.props.translate('self-assessment')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
          disabled: assignment.tasks[0].status == 'ASSIGNMENT_TASK_STARTED' || assignment.tasks[0].status == 'ASSIGNMENT_TASK_NOT_STARTED',
          type: "secondary",
          onClick: this.openSelfAssessment
        }, this.props.translate('assess'))))) : null, teacherAssessments.length > 0 ? /*#__PURE__*/React.createElement("div", {
          className: "single-section"
        }, this.state.loadingBlocks ? /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }) : /*#__PURE__*/React.createElement(AssessmentsConsumer, {
          fields: teacherAssessments,
          assessment: completedTeacherAssessment,
          isStudent: !isTeacher
        })) : null, assignment.assignmentDocuments != null && assignment.assignmentDocuments.length > 0 ? /*#__PURE__*/React.createElement("div", {
          className: "single-section"
        }, /*#__PURE__*/React.createElement("h3", {
          style: {
            fontWeight: 500
          }
        }, this.props.translate('attached-instructions')), /*#__PURE__*/React.createElement(AttachedDocuments, {
          documents: assignment.assignmentDocuments
        })) : null, isTeacher == true ? /*#__PURE__*/React.createElement("div", {
          className: "single-section"
        }, /*#__PURE__*/React.createElement("h3", {
          style: {
            fontWeight: 500
          }
        }, this.props.translate('attached-templates')), /*#__PURE__*/React.createElement(AttachedDocuments, {
          documents: assignment.documentTemplates
        })) : null, isTeacher == false ? /*#__PURE__*/React.createElement("div", {
          className: "single-section",
          style: {
            marginBottom: 0
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex-container row"
        }, /*#__PURE__*/React.createElement("h3", {
          style: {
            fontWeight: 500,
            "float": 'left',
            margin: '0.5rem 0.5rem 0.5rem 0rem'
          }
        }, this.props.translate('my-files'))), /*#__PURE__*/React.createElement("div", {
          className: "flex-container row"
        }, /*#__PURE__*/React.createElement("div", null, assignment.status != 'ASSIGNMENT_CLOSED' ? /*#__PURE__*/React.createElement("div", {
          style: {
            marginTop: 5
          }
        }, /*#__PURE__*/React.createElement(UploadDocument, {
          title: this.props.translate('Add work'),
          assignmentId: assignment.id,
          refreshDocuments: this.refreshDocuments,
          IsSubmitted: assignment.tasks[0].status === 'ASSIGNMENT_TASK_SUBMITTED',
          IsButtonEnable: assignment.tasks[0].status !== 'ASSIGNMENT_TASK_SUBMITTED' && assignment.tasks[0].workspace && assignment.tasks[0].assignmentTaskAssignees.find(function (assignee) {
            return assignee.permission != '0';
          }) != null,
          IsTeachlefter: false,
          onUploadError: this.onUploadError
        })) : null), /*#__PURE__*/React.createElement("div", {
          style: {
            marginLeft: 5
          }
        }, isTeacher || assignment.status == 'ASSIGNMENT_CLOSED' ? null : this.statusSwitcher()))) : null, isTeacher == false ? /*#__PURE__*/React.createElement("div", {
          className: "single-section",
          style: {
            paddingTop: 0
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "clearfix"
        }), /*#__PURE__*/React.createElement(AttachedUserDocuments, {
          assignmentId: assignment.id,
          taskId: assignment.tasks[0].id,
          IsSubmitted: assignment.tasks[0].status === 'ASSIGNMENT_TASK_SUBMITTED' || assignment.status == 'ASSIGNMENT_CLOSED',
          documentRefresh: documentRefresh,
          assignmentTask: assignment.tasks[0]
        })) : null);
      } // Loading section


      return /*#__PURE__*/React.createElement("div", {
        key: "single-assignment-spinner"
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }));
    }
  }]);

  return HaldorAssignment;
}(Component);

function mapStateToProps(state) {
  return {
    activeSection: state.assignments.section,
    activeSchool: state.user.activeSchool,
    currentUser: state.user.currentUser,
    sections: state.sections.educationGroups,
    assessments: state.assessments.assessments,
    studentAssessment: state.assessments.studentAssessment,
    translate: translate(state.Languages.translations),
    services: state.Services.availableServices,
    conversations: state.Conversation.referenceConversations,
    reader: state.user.reader,
    hasValidPlagiarismLicense: state.Plagiarism.hasValidPlagiarismLicense,
    blocks: state.Blocks.reference
  };
}

export default withRouter(connect(mapStateToProps, _objectSpread({
  getAssignmentSection: getAssignmentSection,
  getAssignmentKnowledgeCollections: getAssignmentKnowledgeCollections,
  getAssignmentAssessment: getAssignmentAssessment,
  getStudentAssessment: getStudentAssessment,
  updateAssignment: updateAssignment,
  addError: addError,
  setActiveAssignment: setActiveAssignment,
  clearAssignmentSection: clearAssignmentSection,
  getStudentAssessments: getStudentAssessments,
  deleteAssignmentFromStore: deleteAssignmentFromStore,
  getFolderFiles: getFolderFiles,
  getTaskDetails: getTaskDetails,
  setPageTitle: setPageTitle,
  getReaderParameters: getReaderParameters,
  getAssignmentStatus: getAssignmentStatus,
  getBlocksByReference: getBlocksByReference,
  createStudentAssessment: createStudentAssessment,
  updateAssessment: updateAssessment,
  createAssignmentTaskWorkspace: createAssignmentTaskWorkspace
}, plagiarismActions))(HaldorAssignment));